
import productKeys from '../utils/productKeys.js';
import { getSiblingsGraphQL } from '../utils/helpers.js'

export default {
    props: {
        productData: {
            type: Object,
            required: true
        },
        showBadges: {
            type: Boolean,
            default: false
        },
        showSwatches: {
            type: Boolean,
            default: false
        },
        showWishlist: {
            type: Boolean,
            default: false
        },
        isAlgolia: {
            type: Boolean,
            default: false
        },
        rawFileUrl: {
            type: String,
            default: null
        },
        modelImagePlacement: {
            type: Number,
            default: 2
        }
    },

    data() {
        return {
            product: this.productData,
            url: null,
            // badges: null,
            swatches: null,
            siblings: null,
            hideSwatch: true,
            parsedFileUrl: '',
        }
    },

    computed: {
        isOptionProduct() {
            return this.product?.type?.toLowerCase() === 'prescription app'
        },
        isSale() {
            return this.product?.compare_at_price > this.product.price;
        },
        productName() {
            return this.product.variants[0].sku !== "" ? this.product.variants[0].sku : this.product.title;
        },
        productImage() {
            if (this.isAlgolia) { 
                return [
                    this.product.images[0]?.src || this.product.images[0], // Algolia doesn't store featured images
                    this.product.images[this.modelImagePlacement - 1]?.src || this.product.images[this.modelImagePlacement - 1]
                ]
            }
            else if (this.product.featured_image) {
                let imageSrc = '';
                if (!!this.product.featured_image.src) {
                    imageSrc = this.product.featured_image.abs_src
                } else { // Otherwise its just a straight url/string
                    imageSrc = this.product.featured_image;
                }
                let urlParts = imageSrc.split('.');
                urlParts[urlParts.length - 2] = `${urlParts[urlParts.length - 2]}_x450`;
                let reformedUrl = urlParts.join('.');
                return [
                    reformedUrl,
                    this.product.images[this.modelImagePlacement - 1]?.src || this.product.images[this.modelImagePlacement - 1]
                ];
            }
            return null;
        },
        productTags() {
            return (!!this.product && !!this.product.tags) ? this.product?.tags.map( tag => {
                let tempVal = tag.split(window.commonSeparator);
                return tempVal.length > 1 ? 
                    {
                        "key": tempVal[0]?.toLowerCase(),
                        "value": tempVal[0]?.toLowerCase() === 'model' ? tempVal[1] : tempVal[1]?.toLowerCase()
                    } : false;
            }).filter(tag => tag !== false) : false;
        },
        hasSaleBadge() {
            if (!this.productTags) return false;
            let tag = this.productTags.find( tag => tag.key === 'is_sale' );
            if (!!tag) {
                return tag.value === 'true';
            } else {
                return false;
            }
        },
        productModelByTag() {
            if (!this.productTags) return '';
            let tag = this.productTags.find( tag => tag.key === 'model' );
            if (!!tag) {
                return tag.value;
            } else {
                return this.product?.variants[0].sku || ''
            }
        },


        badges() { // array of product badge/tags/flags

            return this.productTags ?
            
            this.productTags
                // get all the tags with the badge key...
                .filter( badge => badge.key === productKeys.BADGE_KEY )
                
                // ... then map them into a nice array
                .map( e => e.value?.toLowerCase())
                
                // ... then remove all the blank, null or 'empty' values
                .filter( badge => {
                    if (!!badge && badge !== 'empty') {
                        return true
                    }
                    else {
                        return false;
                    }
                })

                // ... then remove Online Only badges, we show it in a different place
                .filter( badge => badge !== 'online only')

                // ... then filter out the ones we shouldn't be showing based on the product type
                .filter( badge => {
                    if (!this.product.type) return true; // if no type is set then fall through
                    
                    let productType = this.product.type.replace(' ', '_')?.toLowerCase(),
                        output = true;

                    // Badges that are only shown for Sunglasses products
                    if (productType !== 'sunglasses') {
                        if (
                            badge === 'prescriptible'
                            ||
                            badge === 'polarised'
                        ) output = false;
                    }

                    // Badges that are only shown for Glasses Frames or Sunglasses products 
                    if (productType === 'contact_lenses') {
                        if (
                            badge === 'asian fit'
                        ) output = false;
                    }

                    return output;
                })
            : 
            [];
        },
    },

    created() {
        if (!this.product.url) {
            this.url = `/products/${this.product.handle}`;
        };


        if (this.product.tags.length > 0) {
            // if (this.showBadges) {
            //     let tempOutput = [];
            //     for (let badge in this.product.tags) {
            //         if (this.product.tags[badge]?.toLowerCase().indexOf('fit_multiselect' + window.commonSeparator) > -1) {
            //             let tagOutput = this.product.tags[badge]?.toLowerCase().split(window.commonSeparator)[1]
            //             if (!!tagOutput) tempOutput.push(tagOutput);
            //         }
            //     };
            //     this.badges = tempOutput;
            // };

            if (this.showSwatches) {
                let tempOutput = [];
                for (let tag in this.product.tags) {
                    if (this.product.tags[tag]?.toLowerCase().indexOf('colour' + window.commonSeparator) > -1) {
                        let tempValue = this.product.tags[tag]?.toLowerCase().split(window.commonSeparator)[1];
                        tempOutput.push({
                            name: tempValue,
                            url: window.parsedFileUrl + tempValue + '.jpg'
                        });
                    }
                };
                this.swatches = tempOutput;
            };

            this.product = this.product;
        };        
    },

    async mounted() {
        this.siblings = this.product.siblings;
        if (!this.siblings && this.showSwatches) {
            this.parsedFileUrl = this.rawFileUrl.replace(/[^\/]+$/,'').substring(0, this.rawFileUrl.lastIndexOf('files'));
            const productInfo = [
                {
                    id: this.product.id,
                    modelTag: this.product.tags.find(tag => tag.includes('model'))
                }
            ]
            let siblings = await getSiblingsGraphQL(productInfo)
            siblings = siblings[0].siblings
            
            let siblingsData = null;

            if (siblings && siblings.length) {
                siblingsData = siblings.map( sibling => {

                    let modelTag = sibling.tags.find( tag => tag.toLowerCase().split('|')[0] === 'model'),
                        modelTagData = modelTag ? (
                            modelTag.split('|')[1].replaceAll('_', ' ').toLowerCase()
                        ) : '',
                        
                        colourDescriptionTag = sibling.tags.find( tag => tag.toLowerCase().split('|')[0] === 'colour_description'),
                        colourDescriptionTagData = colourDescriptionTag ? (
                            colourDescriptionTag.split('|')[1].replaceAll('_', ' ').toLowerCase()
                        ) : '',

                        colourFamilyTag = (sibling.tags.find( tag => tag.toLowerCase().split('|')[0] === 'colour_family') || colourDescriptionTag),
                        colourFamilyTagData = colourFamilyTag ? (
                            colourFamilyTag.split('|')[1].replaceAll(' ', '-').toLowerCase()
                        ) : '',
                        output = {
                            ...sibling,
                            'title': `${modelTagData} ${colourDescriptionTagData}`,
                            'swatchUrl': this.parsedFileUrl + "files/colour-swatch-" + colourFamilyTagData + ".jpg",
                            'url': `/products/${sibling['handle']}`
                        };

                    return !!colourFamilyTagData ? output : false;

                })
                .filter(sibling => !!sibling);
            }
            this.siblings = siblingsData
        }
    },

    methods: {
        checkWishlistProduct(event) {
            if(event.target.classList.contains('iwishAdded')) {
                app.wishListCount =  app.wishListCount - 1;
            } else {
                app.wishListCount =  app.wishListCount + 1;
            }
        },

        reformatTitleContactLenses(title) {
            let splitTitle = title?.toLowerCase().split(' '),
                splitTitleCleaned = splitTitle.filter( word => !!word ), // filter out blank/empty words, in case of extra spaces
                reformattedTitle = splitTitleCleaned.map( word => word[0].toUpperCase() + word.slice(1)).join(' ');

            return reformattedTitle
        },

        toggleSwatches() {
           this.hideSwatch = !this.hideSwatch;

        },
        saveLastScroll () {
            if (document.body.classList.contains('template-collection')) {
                sessionStorage.setItem('PLPLastScroll', window.scrollY)
            }
        }

    }
}